
import React from 'react';
import { FacilityOrderTemplateItemNewFlowDeleteModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateItemNewFlowDeleteModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateItemNewFlowDeleteModalStore(rootStore, componentProps), 'facilityOrderTemplateItemNewFlowDeleteModalStore')
@observer
class FacilityOrderTemplateItemNewFlowDeleteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateItemNewFlowDeleteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateItemNewFlowDeleteModal;
